import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import { TimeRangeSelector } from "../../components/TimeRangeSelector";
import { Moment } from "moment";
import {
  selectDeliveryDateTime,
  selectMeetingFromTime,
  setDeliveryDateTime
} from "../../models/meeting-room-booking-dialog.duck";

export function DeliverySelection(props: Props) {
  const dispatch = useDispatch();
  const deliveryTime = useSelector(selectDeliveryDateTime);
  const meetingStartTime = useSelector(selectMeetingFromTime);
  const {t} = useTranslation();

  const onChange = (from: Moment) => {
    dispatch(setDeliveryDateTime(from));
  }

  return (
    <Container>
      <BodySmall weight={600} colour={Colours.darkGrey}>{t('hospitality.delivery')}:</BodySmall>
      <TimeRangeSelector hour={deliveryTime?.hour() ?? meetingStartTime?.hour() ?? 0}
                         minutes={deliveryTime?.minutes() ?? meetingStartTime?.minutes() ?? 0}
                         style={{width: 200}}
                         disabled={!props.userCanSaveBooking}
                         onTimeChange={onChange}
                         hideLabels={true}
                         hideTimeTo={true} />
    </Container>
  )
}

interface Props {
  userCanSaveBooking: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  p {
    margin-right: 24px;
  }
`
